(function(){
  function ensureStyles(){
    if(document.getElementById('dohte-product-image-zoom-styles')) return;
    const style=document.createElement('style');
    style.id='dohte-product-image-zoom-styles';
    style.textContent=`
      .basket-card__image-slide img{cursor:zoom-in;}
      .dohte-image-zoom{position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;padding:3rem;background:rgba(0,0,0,.82);opacity:0;visibility:hidden;transition:opacity .18s ease,visibility .18s ease;}
      .dohte-image-zoom.is-open{opacity:1;visibility:visible;}
      .dohte-image-zoom__inner{position:relative;display:flex;align-items:center;justify-content:center;max-width:94vw;max-height:94vh;}
      .dohte-image-zoom__image{display:block;max-width:94vw;max-height:94vh;width:auto;height:auto;object-fit:contain;cursor:zoom-out;box-shadow:0 1.2rem 4rem rgba(0,0,0,.35);}
      .dohte-image-zoom__close{position:absolute;top:-1.7rem;right:-1.7rem;width:4rem;height:4rem;border:0;border-radius:50%;background:#fff;color:#1F3A34;font-size:2.7rem;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 .4rem 1.2rem rgba(0,0,0,.25);}
      @media screen and (max-width:749px){.dohte-image-zoom{padding:1.5rem}.dohte-image-zoom__image{max-width:96vw;max-height:88vh}.dohte-image-zoom__close{top:-1rem;right:-.5rem}}
      @media (prefers-reduced-motion:reduce){.dohte-image-zoom{transition:none}}
    `;
    document.head.appendChild(style);
  }

  function ensureModal(){
    let modal=document.querySelector('.dohte-image-zoom');
    if(modal) return modal;
    modal=document.createElement('div');
    modal.className='dohte-image-zoom';
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-label','Imagem ampliada do produto');
    modal.innerHTML='<div class="dohte-image-zoom__inner"><img class="dohte-image-zoom__image" alt=""><button type="button" class="dohte-image-zoom__close" aria-label="Fechar imagem ampliada">×</button></div>';
    document.body.appendChild(modal);
    const image=modal.querySelector('.dohte-image-zoom__image');
    const close=()=>{modal.classList.remove('is-open');document.body.style.overflow='';setTimeout(()=>{if(!modal.classList.contains('is-open')) image.removeAttribute('src')},200)};
    modal.querySelector('.dohte-image-zoom__close').addEventListener('click',close);
    image.addEventListener('click',close);
    modal.addEventListener('click',e=>{if(e.target===modal) close()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal.classList.contains('is-open')) close()});
    return modal;
  }

  function bind(){
    ensureStyles();
    const modal=ensureModal();
    const modalImage=modal.querySelector('.dohte-image-zoom__image');
    document.querySelectorAll('.basket-selector .basket-card__image-slide img').forEach(img=>{
      if(img.dataset.zoomBound==='true') return;
      img.dataset.zoomBound='true';
      img.setAttribute('title','Clique para ampliar');
      img.addEventListener('click',e=>{
        e.preventDefault();
        e.stopPropagation();
        modalImage.src=img.currentSrc||img.src;
        modalImage.alt=img.alt||'Imagem do produto';
        modal.classList.add('is-open');
        document.body.style.overflow='hidden';
        modal.querySelector('.dohte-image-zoom__close').focus();
      });
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bind,{once:true}); else bind();
  document.addEventListener('shopify:section:load',bind);
})();
